import * as React from 'react';
export const boursoramaSvg = React.forwardRef(function boursoramaSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#6EDAFF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.57 7.77 6.883 20.456a3.144 3.144 0 0 0 0 4.396 3.122 3.122 0 0 0 4.397 0l12.531-12.531a1.1 1.1 0 0 0 .066-1.451C23 9.826 22.043 8.814 21.12 7.803a1.1 1.1 0 0 0-1.55-.033Z',
      fill: '#00A0DD',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.884 24.875a3.144 3.144 0 0 1 0-4.398L20.262 7.1a3.11 3.11 0 0 1 4.397 0',
      fill: '#00BDEC',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.422 9.298A3.298 3.298 0 0 1 9.676 6h13.059l-5.672 6.486H9.72a3.167 3.167 0 0 1-3.298-3.188Zm16.236 16.28a3.166 3.166 0 0 1-3.188-3.298v-7.299L26 9.298v13.026a3.296 3.296 0 0 1-3.342 3.254Z',
      fill: '#EB257A',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M25.03 11.134c-.096.175-.21.34-.338.494a3.089 3.089 0 0 1-.363.31l-4.858 4.89V12.53h-4.452l5.039-5.06c.095-.132.2-.256.314-.37a3.122 3.122 0 0 1 4.659 4.034Z',
      fill: '#0073B7',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M22.757 6a3.232 3.232 0 0 0-2.309.935 3.232 3.232 0 0 0-.978 2.363v3.298h3.298a3.298 3.298 0 0 0 2.297-.946c.604-.632.955-1.276.935-2.15-.003-.627-.225-1.443-.56-1.972C24.805 6.594 24 6 22.756 6Z',
      fill: '#1B4580',
    }),
  );
});
boursoramaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var boursorama = {
  category: 'brand',
  colorable: false,
  name: 'boursorama',
  svg: boursoramaSvg,
};
